import OverallProgress from "../features/inventory_dashboard/components/overAllProgressChart";

const strings = {
  jozuna: "Jozuna",
  routing: {
    loginPage: "/",
    forgotPasswordpage: "/forgot-password",
    resetLinkPage: "/reset-link",
    resetPasswordPage: "/reset-password",
    signupPage: "/sign-up",
    initalDashboardPage: "/dashboard/",
    dashboardPage: "/dashboard/student",
    programHub: "/dashboard/learning-room",
    // nested router
    dpAssessmentPage: "/dashboard/assessment",
    dpManageUsers: "/dashboard/manage-users",
    dpQuestionBank: "/dashboard/question-bank",
    dpperformaceReport: "/dashboard/performance-report",
    dpCertificate: "/dashboard/certificate",
    dpAboutUs: "/dashboard/about",
    dpContactPage: "/dashboard/contact-us",
    // nested nested  router(for view)
    createAssessmentPage: "assessment/create-assessment",
    editManageUserPage: "manage-users/edit_User_detail",
    editQuestionPage: "question-bank/edit-quetions",
    interviewHub: "/dashboard/interview-hub",
    certificates: "/dashboard/certificates",
  },
  welcomePage: {
    key: "Upskill to be Future Ready",
  },
  login: {
    emailPlaceholder: "Enter your email",
    passwordPlaceholder: "Enter your password",
    emailLabel: "Email Id",
    password: "Password",
    loginButton: "Welcome Back",
    forgotPassword: "Forgot Password?",
    dontHaveAcc: "Don't have an account?",
    signup: "Signup",
  },
  ForgotPassword: {
    forgotPassword: "Forgot Password",
    enterMAil: "Email ID",
    resetText: "You will receive a link to reset your password",
    continueBtnText: "Continue",
    backToLoginTxt: "Back to login",
  },
  resetPassword: {
    verifyEmailIdHeading: "Check your Email",
    verifyPageContent:
      "Password reset link sent to your email address: john.doe@email.com Please follow the link to continue.",
    verifyEmail: "support@jozuna.com",
    resendTxt: "Resend",
    heading: "Reset Password",
    passwordLabel: "Password*",
    confirmPasswordLabel: "Confirm Password*",
    confirmPasswordPlaceHolder: "Confirm your password",
    saveButton: "Save Password",
  },
  sideMenu: {
    stundentDashText: "Student Dashboard",
    assessmentText: "Assessment",
    questionBankTxt: "Recommendations",
    calender: "Learning Schedule",
    programHub: "Learning Room",
    livesession: "Live Session",
    logoutString: "Are you sure you want to logout?",
    offerings: "Offerings",
    codehub: "Code Hub",
    interviewHub: "InterviewIQ",
    certificates: "Certificates",
  },
  createAssessment: {
    createAssessmentHeading: "Create Assessment",
    edit: "Edit",
    reset: "reset",
    assessmentName: "Assessment Name",
    assessmentCode: "Assessment Code",
    generateLink: "Generate",
    expiryInHour: "Expiry in hours",
    durationInMinutes: "Duration in Minutes",
    startTime: "Start Time",
    assessmentType: "Assessment Type",
    assessmentOption_SelectAssessmentType: "Select Assessment Type",
    //Assessment Type - Jozuna
    JozunaHeading: "Assessment Type: JOZUNA",
    JozunaDomain: "Domain : JOZUNA Skills",
    Jozuna_QuestionCount: "Question Count",
    Jozuna_Option_SelectQuestionCount: "Select Question Count",
    Jozuna_Option_9: "9",
    Jozuna_Option_18: "18",
    Jozuna_Option_27: "27",
    //Assessment type - Industry
    IndustryHeading: "Assessment Type: Industry",
    IndustryDomain: "Domain : Professional",
    IndustryHeaderCategory: "Category",
    IndustryHeaderQuestionCount: "Question Count",
    IndustryHeaderRightAnswerScore: "Right Answer Score",
    IndustryHeaderWrongAnswerScore: "Wrong Answer Score",
    //EditAssessment
    viewAssessment: "Assessment Details",
    editAssessmentHeading: "Edit Assessment",

    saveButton: "Save",
  },

  validation: {
    emailError: "*Enter valid email address",
    loginEmailError: "*Please enter valid email address",
    uidError: "*Please enter your valid uid",
    passwordError: "*Please enter your password",
    passwordLengthError: "*Password should be between 8-16 characters long",
    passwordSpaceError: "*Password should not contain spaces",
    resetPasswordLengthError:
      "Password should have a minimum length of 8 and maximum length of 16 characters, contain atleast one uppercase, one lowercase, one digit, one special character and should not contain any spaces.",
    resetPasswordSpaceError: "Password should not contain spaces",
  },

  needHelp: {
    levelTxt: "Level Up Your Engagement!",
    engScoreQues1: `What is an "Engagement Score"?`,
    engScoreQues1V2: `What are "Completion Steps"?`,
    engScoreQues2: "How can I improve my Engagement Score?",
    engScoreQues2V2: "How to Step Up?",
    progressQues1: `What does the "Overall Progress" score mean?`,
    progressQues2: "How can I see what I still need to do?",
    levelSubTxt: "Here are some quests to boost your score.",
    overAllProgressCardTxtV2:
      "This represents the percentage of all your required learning items (like videos, documents and assessments) that you have completed so far across all your courses. It's a snapshot of how far you've progressed in your learning journey.",
    overAllProgressCardTxt:
      "This represents the percentage of all your required learning items (like videos, assignments, and pop quizzes) that you have completed so far across all your courses. It's a snapshot of how far you've come in your curriculum.",
    overAllProgressPendingCardTxt: `Click the "View Pending Items" button. A window will pop up showing you a categorized list of all the videos you still need to watch and all the assignments or quizzes you still need to complete. Clicking on the respective card will take you to the feature on the platform`,
    engagementScoreTxt:
      "Your Engagement Score is a dynamic measure of how actively you are participating on the platform. It's calculated by looking at several factors, including your video consumption, how many assessments you've attempted, your attendance in live sessions, and your activity in the forums.",
    engagementScoreTxtV2:
      "This isn't just a metric, it's the rhythm of your learning journey. Calculated by your consistency across learning activities, grown by your active involvement on the platform.",
    engagementScoreTxt2V2:
      "Grown by your active involvement across the platform.",
    engagementboostScoreTxt: `Click the "Boost Your Score" button! It will give you specific, actionable tips on how to increase your engagement, such as completing more videos, participating in forums, or attending live sessions.`,
    engagementboostScoreTxtV2:
      "Complete videos, assessments, and learning activities to progress towards completion. Each completed step and interactive activity helps in your learning journey",
    progScheduleQusText: "How does the Learning Schedule work?",
    progScheduleTxt1:
      "Different colors are used to represent different event types for easy identification",
    progScheduleTxt2:
      "Event names are also highlighted with their respective colors for better visibility. Once an event is completed, users receive a notification update. When users click on a particular date, all scheduled events for that day appear in detail. By selecting the “View” option, users can access complete program information, including timings, session details, and activity status.",
  },
  // Add more strings as needed
  learningRoomNeedHelp: {
    accessQus: "How can I access learning contents?",
    accessAns:
      "On the left-hand side of the screen, users can view the different course topics and learning phases included in the program. Topics and others represent individual learning modules within the course. Each topic includes its own videos, PDFs to guide learners step-by-step through the journey.",
    discussQus: "How does the Discussion Board work with learning content?",
    discussAns:
      "Users can ask questions directly to tutors through the Discussion Board. Tutor replies will appear below the respective question for easy tracking and communication. When users click on a video the related Discussion Board section will appear, allowing learners to interact, ask doubts, and participate in discussions connected to that topic.",
    includeQus: "What is included in the Learning Content section?",
    includeAns:
      "The Learning Content section includes video lessons and learning materials provided in the form of PDFs. These resources are designed to support step-by-step learning and help users understand each topic more effectively.",
  },
  modal: {
    Terms: "Terms and Conditions",
    privacy: "Privacy Policy",
    content: "Here is the privacy policy...",
  },

  manage_user: {
    UserDetails: "User Details",
    PersonalDetails: "Personal Details",
    firstName: "First Name",
    lastName: "Last Name",
    emailId: "Email Id",
    gender: "Gender",
    dateOfBirth: "Date of Birth",
    AcademicDetails: "Academic Details",
    admissionYear: "Admission Year",
    education: "Education",
    department: "Department",
    male: "Male",
    female: "Female",
    others: "Others",
    Prefer: "Prefer Not To Say",
  },
  tabNavBar: {
    profile: "Profile",
    settings: "Settings",
    services: "Services Request",
  },
  environments: {
    dev: "DEVELOPMENT",
    qa: "QA",
    prod: "PRODUCTION",
  },
  routes: {
    recommendationIndustryViewPage: "/dashboard/learning-room/view-courses",
  },
  query_key: {
    assessmentDropdownList: "assessmentDropdownList",
  },
  loading: "Loading...",
  error_msg: {
    something_wrg: "Something went wrong",
    error_title: "Error",
  },
  assessment_status: {
    inProgress: "IN_PROGRESS",
    initated: "INITIATED",
    notStarted: "NOTSTARTED",
  },
  assessment_questiontype: {
    descriptive: "Descriptive",
    multipleChoice: "Multiple Choice",
  },
  localStorage_keys: {
    assessment_details: {
      duration: "duration",
      status: "status",
      assessment_id: "assessment_id",
      current_counter: "current_counter",
      time_spend: "time_spend",
      total_question: "total_question",
      isIndependent: "isIndependent",
      candidate_assessment_status: "candidateAssessmentStatus",
      assessment_start_time: "assessment_start_time",
      assessment_expiry_time: "assessment_expiry_time",
      assessment_entity_time_left: "assessment_entity_time_left",
      assessment_entity_id: "assessment_entity_id",
      is_camera_required: "is_camera_required",
    },
  },
  dashboardNeedHelp: {
    jozunaskillPerformance: {
      headerText: `What are these "Jozuna Skills"?`,
      subtext:
        "These are holistic skills that are critical for success in the modern workforce.",
      Features: "Features",
      JozunaSkillsPerformance: "Jozuna Skills Performance",
      skill1: "Learning & Innovation:",
      skill1exp:
        "This skill dimension covers the skills relevant for learning and innovation competency. The skills are - Critical thinking, Communication, Collaboration, Creativity & Innovation",
      skill2: "Information, Media & Technology:",
      skill2exp:
        "This dimension covers the skills related to information processing and media and technology consumption. The skills are - Information Literacy, Media Literacy, Information & Communication Technology (ICT)",
      skill3: "Life & Career:",
      skill3exp:
        "This dimension covers the skills related to life and career progression. The skills are - Flexibility & Adaptability, Initiative & Self-direction, Social & Cross-cultural skills, Productivity & Accountability, and Leadership & Responsibility",
      skill4: "Interdisciplinary:",
      skill4exp:
        "This dimension covers the interdisciplinary skills. These are - Global Awareness, Financial, Economical and Business Entrepreneurship Literacy, Civic Literacy, Health Literacy, Environment Literacy and STEM Awareness",
      trendlinescolors: "Trendlines and Colors",
      upwardtrend: "Upward Trend",
      upwardtrendexp:
        "This shows that you have done better in the given skill dimension compared to earlier assessments",
      neutraltrend: "Neutral Trend",
      neutraltrendexp:
        "This shows that your performance in the given skill dimension has remained constant compared to earlier assessments.",
      downwardtrend: "Downward Trend",
      downwardtrendexp:
        "This shows that you have done worse in the given skill dimension compared to earlier assessments",
      countzerozero: "00%",
      skilltimeline: "Skills Timeline",
      Explanation: "Explanation",
      explanationqs1:
        "What do the skill cards indicate under the Jozuna Skills Performance Card?",
      qs1answer:
        "These cards indicate your overall performance in the **18 Jozuna skills** averaged over all the assessments you have taken. These skills are semantically clubbed under **4 skill dimensions** and the scores are further averaged over all the skills in a dimension and shown in the card.",

      qs2: "What do the trendlines and colors indicate for my Skill Dimension Performance?",
      qs2answer:
        "The trendlines indicate whether your latest performance in the Jozuna Assessments were better or worse than earlier performance.",

      qs3: "How can I see a more detailed breakdown of my skills?",
      qs3answer:
        'Click the "View Detailed Insights" button. This will open a powerful analytics view where you can:',
      clickthe: "Click the",
      viewdetailedinsights: `"View Detailed Insights"`,
      btn: "button. This will open a powerful analytics view where you can:",
      timeline1: "See a Skills Timeline:",
      timeline1exp:
        "A chart showing how your scores for individual skills (like Creativity or Leadership) have improved over time with each assessment.",
      timeline2: "View Assessment Results:",
      timeline2exp:
        "See a detailed breakdown of your performance in a specific assessment, with bar charts showing your scores for each skill measured.",
      century21st:
        "Jozuna 21st century skills are a collection of 18 skills clubbed under the 4 skill dimensions as follows:",
    },
    currskillPerformance: {
      headerText: `What's the difference between "Curriculum Performance" and "Program Performance"?`,
      subtext:
        "These are holistic skills that are critical for success in the modern workforce.",
      answer:
        "The trendlines indicate whether your latest performance in the Assessment was better or worse than earlier performance.",
      upwardtrendexp:
        "This shows that you have done better in the given module/subject compared to earlier assessments",
      neutraltrendexp:
        "This shows that your performance in the given skill dimension has remained constant compared to earlier assessments.",
      downwardtrendexp:
        " This shows that you have done worse in the given module/subject compared to earlier assessments",
      curriculumastery: "Curriculum Performance",
      curriculumasteryexp:
        "focuses on your scores averaged over the past assessments in core academic subjects that are part of your main curriculum (e.g., Data Structures, Algorithms).",
      professionalreadinessexp:
        "focuses on your scores averaged over the past assessments in industry-relevant, practical skills and programs (e.g., Cloud Computing, Database Programming). This is only applicable to users who have assessments configured for industry or program subjects",
      professionalreadiness: "Program Performance ",
      indivtext: "Progress of individual concepts within a subject",
      profreadinesstext: "Professional Readiness subjects by my program",
      indivqs:
        "How do I see the progress of individual concepts within a subject?",
      step1: "Step 1:",
      step1exp:
        "The trendlines indicate whether your latest performance in the Assessment was better or worse than earlier performance.",
      clickthe: "Click the",
      btnon: "button on either card.",
      step2: "Step 2:",
      onthe: "On the",
      progresstimeline: `"Progress Timeline"`,
      OverallProgress: `"Overall Progress"`,
      youwill: "you will land on the",
      menuthat: "menu that shows progress charts for each subject.",
      step3: "Step 3:",
      conceptperformance: '"Concepts Performance"',
      menubesides:
        "the Overall Progress menu. A new screen will appear showing a detailed timeline chart for each specific concept within that subject. (Depending on whether the concepts inventory were a part of the module)",
      note: "*Note: Depending on whether the concepts inventory were a part of the module",
      profreadinessqs:
        "How do I filter the Program Performance subjects by my program?",
      viewdetailedinsights: '"Detailed Insights"',
      dropdowns: "Advance Filter Dropdown",
      inthe: "In the",
      modalfor: "modal for the Program Performance card,you will see",
      atthetop: "at the top.",
      youcanchoose:
        "You can choose to view subjects for a specific program you are enrolled in, or see subjects that are not tied to any specific program.",
      trendlineQs:
        "What do the trendlines and colors indicate for my Curriculum Modules and Professional Subjects Performance?",
    },
  },
  SIDEBAR: {
    LOGO: {
      TITLE: "JOZUNA",
      SUBTITLE: "CAMPUS ERP",
    },
    MENU: {
      stundentDashText: "Student Dashboard",
      assessmentText: "Assessment",
      questionBankTxt: "Recommendations",
      calender: "Learning Schedule",
      programHub: "Learning Room",
      livesession: "Live Session",
      logoutString: "Are you sure you want to logout?",
      offerings: "Offerings",
      codehub: "Code Hub",
      interviewHub: "Interview Hub",
      LOGOUT: "Logout",
    },
  },
  camera_path: "/dashboard/assessment/cameracheck",
};

export default strings;
